import { Archive, Home, Bug, Settings, Cat } from 'lucide-react';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSidebar } from './SidebarContext';
import { OMNITRACKER_URL } from '../../constants/omnitracker';

interface NavigationItem {
  to: string;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  disabled?: boolean;
  external?: boolean;
}

export const SidebarNavigation: React.FC = () => {
  const { isExpanded } = useSidebar();

  const navigationItems: NavigationItem[] = [
    {
      to: '/vorgaenge',
      icon: Home,
      label: 'Startseite',
    },
    {
      to: '/archiv',
      icon: Archive,
      label: 'Archiv',
    },
    {
      to: '/massenverarbeitung',
      icon: Cat,
      label: 'Massenverarbeitung',
    },
    {
      to: '/konfiguration',
      icon: Settings,
      label: 'Konfiguration',
    },
    // {
    //   to: '/fehler',
    //   icon: AlertTriangle,
    //   label: 'Fehler Mgmt',
    // },
    // {
    //   to: '/opm-mgmt',
    //   icon: Settings,
    //   label: 'OPM Mgmt',
    //   disabled: true,
    // },
    {
      to: OMNITRACKER_URL,
      icon: Bug,
      label: 'Fehlerticket erstellen',
      external: true,
    },
  ];

  return (
    <nav className="space-y-4 p-4">
      {navigationItems.map((item) => {
        const IconComponent = item.icon;

        if (item.disabled) {
          return (
            <div
              key={item.to}
              className={`flex items-center rounded-md text-sm font-medium text-sidebar-foreground/40 h-16 ${
                isExpanded ? 'gap-3 px-4' : 'justify-center w-16 mx-auto'
              }`}
              title={!isExpanded ? item.label : undefined}
            >
              <IconComponent className="h-5 w-5 flex-shrink-0" />
              {isExpanded && <span className="truncate">{item.label}</span>}
            </div>
          );
        }

        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => {
              const baseClasses = `flex items-center rounded-md text-sm font-medium transition-colors h-16 ${
                isExpanded ? 'gap-3 px-4' : 'justify-center w-16 mx-auto'
              }`;
              const activeClasses =
                'bg-sidebar-primary text-sidebar-primary-foreground';
              const inactiveClasses =
                'text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground';

              return `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`;
            }}
            title={!isExpanded ? item.label : undefined}
            target={item.external ? '_blank' : undefined}
            rel={item.external ? 'noopener noreferrer' : undefined}
          >
            <IconComponent className="h-5 w-5 flex-shrink-0" />
            {isExpanded && <span className="truncate">{item.label}</span>}
          </NavLink>
        );
      })}
    </nav>
  );
};
